import React from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertTriangle } from "lucide-react";

/**
 * Banner shown at the top whenever the current session is impersonating
 * another user. Lets the admin exit impersonation in one click.
 */
export default function ImpersonationBanner() {
  const { user, checkAuth } = useAuth();
  if (!user?.is_impersonated) return null;

  const exit = async () => {
    try {
      await api.post("/admin/impersonation/stop");
    } catch {
      /* ignore */
    }
    await checkAuth();
    window.location.href = "/admin/users";
  };

  return (
    <div
      className="bg-amber-400 text-black border-b border-amber-600 sticky top-0 z-[60]"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between text-sm">
        <div className="flex items-center gap-2 font-medium">
          <AlertTriangle size={14} />
          You are viewing AnswerWatch as{" "}
          <span className="mono font-bold">{user.email}</span>
        </div>
        <button
          onClick={exit}
          data-testid="impersonation-exit"
          className="bg-black text-white text-xs px-3 py-1 rounded-[4px] hover:bg-zinc-800"
        >
          Exit impersonation
        </button>
      </div>
    </div>
  );
}
